<template>
  <div class="w-full px-0">
    <div class="relative w-full h-[40px] bg-transparent flex justify-center">
      <div class="absolute top-1/2 w-full h-[8px] bg-gradient-to-r from-transparent via-[#FEFE00] to-transparent blur-[2px]"></div>
      <div class="absolute top-1/2 w-[100%] h-[30px] bg-gradient-to-r from-transparent via-[#FEFE00] to-transparent blur-xl opacity-100 -translate-y-1/2"></div>
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 translate-y-[4px] w-0 h-0 border-l-[8px] border-r-[8px] border-t-[12px] border-l-transparent border-r-transparent border-t-[#FEFE00]"></div>
    </div>
    <div class="h-[150px] md:h-[300px] flex items-center justify-center gap-4 overflow-hidden carousel-container">
      <div class="flex gap-4">
        <GiftComponent
          v-for="(gift, index) in visibleGifts"
          :key="`${gift.id}-${index}`" 
          :gift="gift"
          :isWinning="index === 2 && !isSpinning && hasSpun"
          class="gift-item"
          :class="{ 
            'opacity-100': index === 2 && !isSpinning && !hasSpun,
            'opacity-60': index !== 2 || isSpinning 
          }"
        />
      </div>
    </div>
    <div class="relative w-full h-[40px] bg-transparent flex justify-center">
      <div class="absolute top-1/2 w-full h-[8px] bg-gradient-to-r from-transparent via-[#FEFE00] to-transparent blur-[2px]"></div>
      <div class="absolute top-1/2 w-full h-[30px] bg-gradient-to-r from-transparent via-[#FEFE00] to-transparent blur-xl opacity-100 -translate-y-1/2"></div>
      <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[8px] w-0 h-0
    border-l-[8px] border-r-[8px] border-b-[12px]
    border-l-transparent border-r-transparent border-b-[#FEFE00]">
      </div>
    </div>
  </div>
</template>

<script>
import GiftComponent from "@/pages/version3/components/Gift.vue";
import {GET_GIFT_LIST} from "@/common/apiUrl";

export default {
  name: 'CarouselSpin',
  components: {GiftComponent},
  data() {
    return {
      isMobile: window.innerWidth < 767,
      gifts: [],
      URL_API_EDUTALK: process.env.VUE_APP_API_URL,
      isSpinning: false,
      currentIndex: 0,
      winningGiftId: null,
      visibleGifts: [],
      animationStep: 0,
      hasSpun: false,
    }
  },
  mounted() {
    this.getLisGift()
  },
  methods: {
    async getLisGift() {
      const response = await fetch(`${this.URL_API_EDUTALK}/${GET_GIFT_LIST}`);
      const gift_list = await response.json();
      this.gifts = gift_list.data;
      this.initializeVisibleGifts();
    },
    initializeVisibleGifts() {
      if (this.gifts.length === 0) return;
      this.visibleGifts = this.gifts.slice(0, 5);
      this.currentIndex = 0;
    },

    async startSpin(winningGiftId) {
      if (this.isSpinning) return;
      
      this.isSpinning = true;
      this.winningGiftId = winningGiftId;
      this.hasSpun = true;
      const winningIndex = this.gifts.findIndex(gift => gift.id === winningGiftId);
      
      if (winningIndex === -1) {
        console.error('Không tìm thấy phần quà trúng thưởng');
        this.isSpinning = false;
        return;
      }

      const totalGifts = this.gifts.length;
      const fullRotations = 2;
      const totalSteps = fullRotations * totalGifts + winningIndex;

      await this.performSpinAnimation(totalSteps);
      
      this.isSpinning = false;
    },

    async performSpinAnimation(totalSteps) {
      return new Promise((resolve) => {
        let currentStep = 0;
        const animationDuration = 3000;
        const stepDuration = animationDuration / totalSteps;
        
        const animate = () => {
          if (currentStep < totalSteps) {
            this.updateVisibleGifts(currentStep);
            currentStep++;
            setTimeout(animate, stepDuration);
          } else {
            this.setWinningGiftInCenter();
            resolve();
          }
        };
        
        animate();
      });
    },

    updateVisibleGifts(currentStep) {
      const totalGifts = this.gifts.length;
      const startIndex = currentStep % totalGifts;
      this.visibleGifts = [];
      for (let i = 0; i < 5; i++) {
        const giftIndex = (startIndex + i) % totalGifts;
        this.visibleGifts.push(this.gifts[giftIndex]);
      }
    },
    setWinningGiftInCenter(giftId = null) {
      const targetGiftId = giftId || this.winningGiftId;
      const winningIndex = this.gifts.findIndex(gift => gift.id === targetGiftId);
      
      if (winningIndex === -1) {
        console.error('Không tìm thấy phần quà với ID:', targetGiftId);
        return;
      }
      
      this.visibleGifts = [];
      for (let i = 0; i < 5; i++) {
        const giftIndex = (winningIndex - 2 + i + this.gifts.length) % this.gifts.length;
        this.visibleGifts.push(this.gifts[giftIndex]);
      }
    }
  }
}
</script>

<style scoped>
.carousel-container {
  position: relative;
}

.carousel-track {
  transition: transform 0.1s ease-out;
}

.gift-item {
  transition: opacity 0.3s ease-in-out;
}

.spinning {
  animation: spin 0.1s linear infinite;
}

@keyframes spin {
  from {
    transform: translateX(var(--translate-x)) rotate(0deg);
  }
  to {
    transform: translateX(var(--translate-x)) rotate(360deg);
  }
}
</style>